import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getUnitMembers(axiosPrivate, unitId, phrase) {
	return axiosPrivate
		.get(`${apiURL}/organization-unit/${unitId}/members/list.json${phrase ? `?phrase=${phrase.replace(" ", "%20")}` : ""}`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getAvailableUnitMembers(axiosPrivate, phrase, unitId) {
	try {
		// First get current user profile to get their ID
		const currentUserRes = await axiosPrivate.get(`${apiURL}/user/profile.json`);
		const currentUserId = currentUserRes.data?.id;

		// Try admin endpoint first to get createdById information
		try {
			const adminResponse = await axiosPrivate.get(`${apiURL}/admin/user.json${phrase ? "?phrase=" + phrase : ""}`);
			
			if (adminResponse.status > 199 && adminResponse.status < 300) {
				const resultUsers = [];

				for (const person of adminResponse.data) {
					let isAlreadyAdded = false;
					const units = person.organizationUnits;
					for (const unit of units) {
						if (parseInt(unit.organizationUnit.id) === parseInt(unitId)) isAlreadyAdded = true;
					}
					
					// Only include users that are:
					// 1. Not already added to this unit
					// 2. Created by the current user (if createdById is available)
					if (!isAlreadyAdded && (person.createdById === currentUserId || !person.createdById)) {
						resultUsers.push(person);
					}
				}

				return resultUsers;
			}
		} catch (adminError) {
			console.log("Admin endpoint not accessible, falling back to regular endpoint");
		}

		// Fallback to regular endpoint if admin is not accessible
		const response = await axiosPrivate.get(`${apiURL}/user.json${phrase ? "?phrase=" + phrase : ""}`);
		
		if (response.status > 199 && response.status < 300) {
			const resultUsers = [];

			for (const person of response.data) {
				let isAlreadyAdded = false;
				const units = person.organizationUnits;
				for (const unit of units) {
					if (parseInt(unit.organizationUnit.id) === parseInt(unitId)) isAlreadyAdded = true;
				}
				
				// Without createdById info, show all available users
				if (!isAlreadyAdded) {
					resultUsers.push(person);
				}
			}

			return resultUsers;
		}
	} catch (err) {
		console.error("Error fetching users:", err);
		return err.response;
	}
}

export async function deleteUnitMember(axiosPrivate, cb, unitId, userId) {
	return axiosPrivate
		.delete(`${apiURL}/organization-unit/${unitId}/member/${userId}.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Member - removed");
				cb();
			} else {
				toast.error("Mamber failed to be removed");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function registerUnitMember(axiosPrivate, cb, unitId, data) {
	return axiosPrivate
		.post(`${apiURL}/organization-unit/${unitId}/member/create.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Member - registered");
				cb();
			} else {
				toast.error("Mamber failed to be registered");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function addUnitMembers(axiosPrivate, cb, unitId, data) {
	return axiosPrivate
		.post(`${apiURL}/organization-unit/${unitId}/member.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Member - added");
				cb();
			} else {
				toast.error("Mamber failed to be added");
			}
			return res;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function changeUnitMemberRole(axiosPrivate, cb, unitId, userId, data) {
	return axiosPrivate
		.put(`${apiURL}/organization-unit/${unitId}/member/${userId}.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Member roles - changes");
				cb();
			} else {
				toast.error("Mamber roles failed to be changed");
			}
		})
		.catch((err) => {
			return err.response;
		});
}
